export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL + "access/";
// export const BACKEND_URL_2 = 'http://lambda-dev.conceptx-ai.com/';
// export const BACKEND_URL = 'http://lambda-dev.conceptx-ai.com:8003/access/';
export const BACKEND_URL_2 = process.env.REACT_APP_BACKEND_URL;

//auth
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const TOKEN_CHECK = "TOKEN_CHECK";
export const TOKEN_CHECK_FAIL = "TOKEN_CHECK_FAIL";
export const LOGIN_ALERT_REMOVE = "LOGIN_ALERT_REMOVE";
export const LOGOUT = "LOGOUT";
export const RESET_SUCCESS = "RESET_SUCCESS";
export const RESET_FAILED = "RESET_FAILED";
export const GET_USER_DATA_BY_EMAIL = "GET_USER_DATA_BY_EMAIL";
export const SET_LOADING_FALSE = "SET_LOADING_FALSE";
export const SET_LOGOUT_PROVISION = "SET_LOGOUT_PROVISION";
export const FIRST_TIMER = "FIRST_TIMER";
export const SET_URL_META_DATA = "SET_URL_META_DATA";
export const SET_DIV_TOGGLE = "SET_DIV_TOGGLE";
export const LOGIN_CALL_TOP_CARD = "LOGIN_CALL_TOP_CARD";
export const UPDATE_TOKEN = "UPDATE_TOKEN";
export const FILTER_DATA = "FILTER_DATA";

//ASSET TYPE CREATION
export const ASSET_TYPE_ALERT = "ASSET_TYPE_ALERT";
export const ASSET_TYPE_LIST_DATA = "ASSET_TYPE_LIST_DATA";
export const ASSET_CLASS_TYPE_LIST_DATA = "ASSET_CLASS_TYPE_LIST_DATA";
export const ASSET_TYPE_SINGLE_DATA = "ASSET_TYPE_SINGLE_DATA";

//company
export const CREATE_COMPANY_SUCCESS = "CREATE_COMPANY_SUCCESS";
export const CREATE_COMPANY_FAILED = "CREATE_COMPANY_FAILED";
export const REMOVE_COMPANY_ALERT = "REMOVE_COMPANY_ALERT";
export const CLOSE_ADD_MODAL = "CLOSE_ADD_MODAL";
export const CLOSE_EDIT_MODAL = "CLOSE_EDIT_MODAL";
export const CLOSE_ADD_MODAL_RESET = "CLOSE_ADD_MODAL_RESET";
export const CLOSE_EDIT_MODAL_RESET = "CLOSE_EDIT_MODAL_RESET";
export const LIST_COMPANY_SUCESS = "LIST_COMPANY_SUCESS";
export const LIST_COMPANY_FAILED = "LIST_COMPANY_FAILED";
export const EDIT_COMPANY_DATA = "EDIT_COMPANY_DATA";
export const DEACTIVATE_COMPANY_SUCCESS = "DEACTIVATE_COMPANY_SUCCESS";
export const DEACTIVATE_COMPANY_FAILED = "DEACTIVATE_COMPANY_FAILED";
export const EDIT_COMPNAY_FAILED = "EDIT_COMPNAY_FAILED";
export const EDIT_COMPNAY_SUCCESS = "EDIT_COMPNAY_SUCCESS";
export const DEACTIVE_USER_ROLE_FAILED = "DEACTIVE_USER_ROLE_FAILED";
export const SETTINGS_DATA_SUCCESS = "SETTINGS_DATA_SUCCESS";
export const ALERT_FOR_ASSET_COMPANY_MAPPING =
  "ALERT_FOR_ASSET_COMPANY_MAPPING";
export const SET_CREATED_ID = "SET_CREATED_ID";
export const SET_COMPANY_ASSET_TYPE_DATA = "SET_COMPANY_ASSET_TYPE_DATA";
export const SET_COMPANY_ASSET_TYPE_DATA_T = "SET_COMPANY_ASSET_TYPE_DATA_T";

//user
export const CHECK_USER_EMAIL_VALID = "CHECK_USER_EMAIL_VALID";
export const CHECK_USER_EMAIL_INVALID = "CHECK_USER_EMAIL_INVALID";
export const REGISTER_USER_FAILED = "REGISTER_USER_FAILED";
export const COMPANY_ALERT_REMOVE = "COMPANY_ALERT_REMOVE";
export const GET_ROLE_ERROR = "GET_ROLE_ERROR";
export const USER_ASSIGNED_SUCCESS = "USER_ASSIGNED_SUCCESS";
export const ADD_OLD_USER_ID = "ADD_OLD_USER_ID";
export const RESET_ERROR_USER = "RESET_ERROR_USER";

//project
export const LIST_PROJECT_SUCCESS = "LIST_PROJECT_SUCCESS";
export const LIST_PROJECT_SUCCESS_SCP = "LIST_PROJECT_SUCCESS_SCP";

export const LIST_PROJECT_FAILED = "LIST_PROJECT_FAILED";
export const REMOVE_PROJECT_ALERT = "REMOVE_PROJECT_ALERT";
export const ADD_PROJECT_SUCCESS = "ADD_PROJECT_SUCCESS";
export const ADD_PROJECT_FAILED = "ADD_PROJECT_FAILED";
export const SET_ISOPEN_PROJECT = "SET_ISOPEN_PROJECT";
export const REMOVE_ISOPEN_PROJECT = "REMOVE_ISOPEN_PROJECT";
export const UNDER_PROCESSING_PROJECT = "UNDER_PROCESSING_PROJECT";
export const LOADING_TRUE_PROJECT = "LOADING_TRUE_PROJECT";
export const LOADING_FALSE_PROJECT = "LOADING_FALSE_PROJECT";
export const DEACTIVATE_PROJECT_SUCCESS = "DEACTIVATE_PROJECT_SUCCESS";
export const DEACTIVATE_PROJECT_FAILED = "DEACTIVATE_PROJECT_FAILED";

export const EDIT_PROJECT_DATA = "EDIT_PROJECT_DATA";
export const EDIT_PROJECT_FAILED = "EDIT_PROJECT_FAILED";
export const EDIT_PROJECT_SUCCESS = "EDIT_PROJECT_SUCCESS";

// assignAccess
export const LIST_ASSIGN_USER_SUCCESS = "LIST_ASSIGN_USER_SUCCESS";
export const LIST_ASSIGN_USER_FAILED = "LIST_ASSIGN_USER_FAILED";
export const REMOVE_ACCESS_ALERT = "REMOVE_ACCESS_ALERT";
export const SET_AUTOCALL = "SET_AUTOCALL";
export const REMOVE_AUTOCALL = "REMOVE_AUTOCALL";
export const LOADING_FALSE = "LOADING_FALSE";
export const RESET_ASSIGN_ACCESS = "RESET_ASSIGN_ACCESS";
export const ADD_ASSIGN_FAILED = "ADD_ASSIGN_FAILED";
export const EDIT_ASSIGN_SUCCESS = "EDIT_ASSIGN_SUCCESS";
export const EDIT_ASSIGN_FAILED = "EDIT_ASSIGN_FAILED";
export const ADD_ASSIGN_SUCCESS = "ADD_ASSIGN_SUCCESS";
export const SET_ISOPEN_ASSING = "SET_ISOPEN_ASSING";
export const REMOVE_ISOPEN_ASSING = "REMOVE_ISOPEN_ASSING";
export const EDIT_USER_ASSIGN_DATA = "EDIT_USER_ASSIGN_DATA";
export const BULK_UPLOAD_SUCCESS = "BULK_UPLOAD_SUCCESS";
export const BULK_UPLOAD_FAILED = "BULK_UPLOAD_FAILED";
export const UNDER_PROCESSING = "UNDER_PROCESSING";
export const LOADING_TRUE_ASSIGN = "LOADING_TRUE_ASSIGN";

//user Management
export const LIST_USER_LIST_DATA_SUCCESS = "LIST_USER_LIST_DATA_SUCCESS";
export const LIST_USER_LIST_DATA_FAILED = "LIST_USER_LIST_DATA_FAILED";
export const ADD_USER_LIST_DATA_SUCCESS = "ADD_USER_LIST_DATA_SUCCESS";
export const ADD_USER_LIST_DATA_FAILED = "ADD_USER_LIST_DATA_FAILED";
export const EDIT_USER_LIST_DATA_SUCCESS = "EDIT_USER_LIST_DATA_SUCCESS";
export const EDIT_USER_LIST_DATA_FAILED = "EDIT_USER_LIST_DATA_FAILED";
export const SET_ISOPEN_USER_LIST_DATA = "SET_ISOPEN_USER_LIST_DATA";
export const REMOVE_ISOPEN_USER_LIST_DATA = "REMOVE_ISOPEN_USER_LIST_DATA";
export const REMOVE_USER_LIST_DATA_ALERT = "REMOVE_USER_LIST_DATA_ALERT";
export const LIST_USER_BY_EMAIL_DATA_SUCESS = "LIST_USER_BY_EMAIL_DATA_SUCESS";
export const LIST_USER_BY_EMAIL_DATA_FAILED = "LIST_USER_BY_EMAIL_DATA_FAILED";
export const LIST_USER_COMPANY_LIST_SUCCESS = "LIST_USER_COMPANY_LIST_SUCCESS";
export const LIST_USER_COMPANY_LIST_FAILED = "LIST_USER_COMPANY_LIST_FAILED";
export const LIST_USER_PROJECT_LIST_SUCCESS = "LIST_USER_PROJECT_LIST_SUCCESS";
export const LIST_USER_PROJECT_LIST_FAILED = "LIST_USER_PROJECT_LIST_FAILED";

//assets
export const LIST_ASSETS_SUCCESS = "LIST_ASSETS_SUCCESS";
export const LIST_ASSETS_FAILED = "LIST_ASSETS_FAILED";
export const CREATE_ASSETS_SUCCESS = "CREATE_ASSETS_SUCCESS";
export const CREATE_ASSETS_FAILED = "CREATE_ASSETS_FAILED";
export const CLEAR_ASSETS_ERROR = "CLEAR_ASSETS_ERROR";
export const SET_ASSETS_ISOPEN = "SET_ASSETS_ISOPEN";
export const SET_ASSET_EDIT_DATA = "SET_ASSET_EDIT_DATA";
export const SET_ALERT_ASSET = "SET_ALERT_ASSET";

//plan
export const LIST_PLANS_SUCCESS = "LIST_PLANS_SUCCESS";
export const LIST_PLANS_FAILED = "LIST_PLANS_FAILED";
export const CREATE_PLANS_SUCCESS = "CREATE_PLANS_SUCCESS";
export const CREATE_PLANS_FAILED = "CREATE_PLANS_FAILED";
export const CLEAR_PLANS_ERROR = "CLEAR_PLANS_ERROR";
export const SET_PLANS_ISOPEN = "SET_PLANS_ISOPEN";
export const SET_PLAN_EDIT_DATA = "SET_PLAN_EDIT_DATA";
export const SET_PLAN_DETAILS_LOADING = "SET_PLAN_DETAILS_LOADING";
export const SET_ALERT_PLAN = "SET_ALERT_PLAN";
export const CLEAR_EDIT_PLAN_DATA = "CLEAR_EDIT_PLAN_DATA";
export const LIST_PLAN_ASSETS_FAILED = "LIST_PLAN_ASSETS_FAILED";
export const LIST_PLAN_ASSETS_SUCCESS = "LIST_PLAN_ASSETS_SUCCESS";
export const TRIGGER_TURBINE_SECTION_API = "TRIGGER_TURBINE_SECTION_API";
export const SELECTED_PLAN_ID = "SELECTED_PLAN_ID";
export const TRIGGER_FILTER_DATA = "TRIGGER_FILTER_DATA";
export const AI_MODE_CONFIG = "AI_MODE_CONFIG";
export const GENERATING_ML_DATA = "GENERATING_ML_DATA";
export const GENERATING_ML_DATA_STATUS = "GENERATING_ML_DATA_STATUS";

//dataaudit
export const LIST_ASSET_SECTIONS_SUCCESS = "LIST_ASSET_SECTIONS_SUCCESS";
export const LIST_ASSET_SECTIONS_FAILED = "LIST_ASSET_SECTIONS_FAILED";
export const UPLOAD_SECTION_LISTS = "UPLOAD_SECTION_LISTS";
export const ADD_TURBINE_SECTION_FAILED = "ADD_TURBINE_SECTION_FAILED";
export const ADD_TURBINE_SECTION_SUCCESS = "ADD_TURBINE_SECTION_SUCCESS";
export const RESET_TURBINE_SECTION_ADD = "RESET_TURBINE_SECTION_ADD";
export const QUEUE_LIST = "QUEUE_LIST";
export const ADD_GET_PROGRESS_SET = "ADD_GET_PROGRESS_SET";
export const SET_ASSET_IMAGES = "SET_ASSET_IMAGES";
export const SET_ASSET_IMAGES_UNMAPPED = "SET_ASSET_IMAGES_UNMAPPED";
export const SET_ASSET_IMAGES_LOADER = "SET_ASSET_IMAGES_LOADER";
export const SET_ASSET_IMAGES_LOADER_UNMAPPED =
  "SET_ASSET_IMAGES_LOADER_UNMAPPED";
export const SET_ASSET_IMAGES_LOADER_2 = "SET_ASSET_IMAGES_LOADER_2";
export const SET_ASSET_IMAGES_DATA_2 = "SET_ASSET_IMAGES_DATA_2";
export const SET_BLADE_SECTION_DATA = "SET_BLADE_SECTION_DATA";
export const SET_BLADE_SECTION_DATA_LOADING = "SET_BLADE_SECTION_DATA_LOADING";
export const SET_ALERT_DATA_AUDIT = "SET_ALERT_DATA_AUDIT";
export const SET_DATA_SECTION_LOADING = "SET_DATA_SECTION_LOADING";
export const SET_DATA_EXPORT_LOADING = "SET_DATA_EXPORT_LOADING";
export const SET_DATA_DELETE_LOADING_2 = "SET_DATA_DELETE_LOADING_2";
export const SET_BTN_FALSE = "SET_BTN_FALSE";
export const SET_THRESHOLD_DATA = "SET_THRESHOLD_DATA";
export const IN_PROGRESS_RAW_UPLOAD = "IN_PROGRESS_RAW_UPLOAD";
export const IN_PROGRESS_RAW_UPLOAD_COUNT = "IN_PROGRESS_RAW_UPLOAD_COUNT";
export const IN_PROGRESS_ENHANCE_UPLOAD_COUNT =
  "IN_PROGRESS_ENHANCE_UPLOAD_COUNT";
export const IN_UPLOADING_RAW_UPLOAD = "IN_UPLOADING_RAW_UPLOAD";
//v2
export const LIST_ASSET_UPLOADED_DATA_V2 = "LIST_ASSET_UPLOADED_DATA_V2";
export const TRIGGER_CHECK_API = "TRIGGER_CHECK_API";
export const DAMAGE_DATA_ANALYSE_LOADING = "DAMAGE_DATA_ANALYSE_LOADING";
export const DELETE_BASE_LAYER_LOADING = "DELETE_BASE_LAYER_LOADING";

//process
export const LIST_UNIQUE_ASSET_SECTION = "LIST_UNIQUE_ASSET_SECTION";
export const SET_PROCESS_ALERT = "SET_PROCESS_ALERT";
export const LIST_PROCESS_DATA_SUCCESS = "LIST_PROCESS_DATA_SUCCESS";
export const LIST_PROCESS_DATA_FAILED = "LIST_PROCESS_DATA_FAILED";
export const LIST_STITCHED_PROCESS_DATA_SUCCESS =
  "LIST_STITCHED_PROCESS_DATA_SUCCESS";
export const LIST_STITCHED_PROCESS_DATA_FAILED =
  "LIST_STITCHED_PROCESS_DATA_FAILED";
export const LIST_ENHANCED_DATA_SUCCESS = "LIST_ENHANCED_DATA_SUCCESS";
export const LIST_ENHANCED_DATA_FAILED = "LIST_ENHANCED_DATA_FAILED";
export const LIST_ENHANCED_DATA_SUCCESS_LOADING =
  "LIST_ENHANCED_DATA_SUCCESS_LOADING";
export const PROCESS_TAB_INPROGRESS = "PROCESS_TAB_INPROGRESS";
export const IN_UPLOADING_ENHANCE_UPLOAD = "IN_UPLOADING_ENHANCE_UPLOAD";
export const SET_DATA_DELETE_LOADING = "SET_DATA_DELETE_LOADING";

//Analyse
export const LIST_ANALYSE_SUCCESS = "LIST_ANALYSE_SUCCESS";
export const LIST_ANALYSE_FAILED = "LIST_ANALYSE_FAILED";
export const LIST_SET_ALERT_ANALYSE = "LIST_SET_ALERT_ANALYSE";
export const LIST_ANNOTATION_DATA = "LIST_ANNOTATION_DATA";
export const SET_ANALYSE_SECTION_ID = "SET_ANALYSE_SECTION_ID";
export const LIST_STITCHED_ANALYSE_DATA_SUCCESS =
  "LIST_STITCHED_ANALYSE_DATA_SUCCESS";
export const LIST_IMAGE_ANALYSE_DATA_SUCCESS =
  "LIST_IMAGE_ANALYSE_DATA_SUCCESS";
export const LIST_STITCHED_ANALYSE_DATA_SUCCESS_LOADING =
  "LIST_STITCHED_ANALYSE_DATA_SUCCESS_LOADING";
export const LIST_STITCHED_RAW_SUCCESS_LOADING =
  "LIST_STITCHED_RAW_SUCCESS_LOADING";
export const LIST_DAMAGE_DATA = "LIST_DAMAGE_DATA";
export const LOADING_ANNOTATION_DATA = "LOADING_ANNOTATION_DATA";
export const LIST_ENHANCE_IMAGE_ANALYSE_DATA_SUCCESS =
  "LIST_ENHANCE_IMAGE_ANALYSE_DATA_SUCCESS";
export const LIST_ENHANCE_IMAGE_ANALYSE_DATA_SUCCESS_LOADING =
  "LIST_ENHANCE_IMAGE_ANALYSE_DATA_SUCCESS_LOADING";
export const SELECT_DAMAGE_AUTOMATIC = "SELECT_DAMAGE_AUTOMATIC";
export const IN_PROGRESS_ENHANCE_UPLOAD = "IN_PROGRESS_ENHANCE_UPLOAD";
export const IN_PROGRESS_STITCH_UPLOAD = "IN_PROGRESS_STITCH_UPLOAD";
export const SET_NEW_DAMAGE_ID = "SET_NEW_DAMAGE_ID";
export const TRIGGER_MARK_NO_DAMAGE = "TRIGGER_MARK_NO_DAMAGE";
export const TRIGGER_MARK_NO_DAMAGE_2 = "TRIGGER_MARK_NO_DAMAGE_2";
export const SAVE_LOADING_STOP = "SAVE_LOADING_STOP";

//set ai mode
export const SET_AI_MODE = "SET_AI_MODE";

//Reports
export const LIST_REPORTS_SUCCESS = "LIST_REPORTS_SUCCESS";
export const LIST_SEGMENTED_DATA = "LIST_SEGMENTED_DATA";
export const LIST_SEGMENTED_DATA_LOADING = "LIST_SEGMENTED_DATA_LOADING";
export const LIST_REPORTS_FAILED = "LIST_REPORTS_FAILED";
export const SET_ALERT_FOR_REPORTS = "SET_ALERT_FOR_REPORTS";
export const LIST_REPORT_FILES = "LIST_REPORT_FILES";
export const LIST_REPORT_FILES_LOADING = "LIST_REPORT_FILES_LOADING";

export const LIST_REPORTS_DAMAGE_SUCCESS = "LIST_REPORTS_DAMAGE_SUCCESS";
export const LIST_REPORTS_DAMAGE_FAILED = "LIST_REPORTS_DAMAGE_FAILED";
export const LIST_REPORTS_DAMAGE_IMAGE_SUCCESS =
  "LIST_REPORTS_DAMAGE_IMAGE_SUCCESS";
export const LIST_REPORTS_DAMAGE_IMAGE_FAILED =
  "LIST_REPORTS_DAMAGE_IMAGE_FAILED";
export const DOWNLOAD_LOADING_REPORT = "DOWNLOAD_LOADING_REPORT";
export const GENERATING_LOADING_REPORT = "GENERATING_LOADING_REPORT";
export const GENERATING_STATUS_MESSAGE = "GENERATING_STATUS_MESSAGE";
export const LOADING_DATA_REPORT = "LOADING_DATA_REPORT";
export const LOADING_DATA_REPORT_UPLOAD = "LOADING_DATA_REPORT_UPLOAD";
export const LOADING_BASE_LAYER = "LOADING_BASE_LAYER";
export const BASE_LAYER_DATA = "BASE_LAYER_DATA";
export const LOADING_ASSET_LAYER = "LOADING_ASSET_LAYER";
export const BASE_ASSET_DATA = "BASE_ASSET_DATA";
export const LOADING_ANNOTATION_LAYER = "LOADING_ANNOTATION_LAYER";
export const BASE_ANNOTATION_DATA = "BASE_ANNOTATION_DATA";
export const RESET_REPORTS = "RESET_REPORTS";

//default configuration
export const LIST_DAMAGE_TYPE_DATA = "LIST_DAMAGE_TYPE_DATA";
export const LIST_DAMAGE_TYPE_DATA_CLIENT = "LIST_DAMAGE_TYPE_DATA_CLIENT";
export const LIST_SEVERITY_TYPE_DATA = "LIST_SEVERITY_TYPE_DATA";
export const LIST_SEVERITY_TYPE_DATA_CLIENT = "LIST_SEVERITY_TYPE_DATA_CLIENT";
export const ALERT_DEFAULT_CONFIGURATION = "ALERT_DEFAULT_CONFIGURATION";
export const SET_CLIENT_ASSET_TYPES = "SET_CLIENT_ASSET_TYPES";
export const SET_CLIENT_ASSET_TYPES_2 = "SET_CLIENT_ASSET_TYPES_2";
export const SET_COMPNAY_LOGO_URL = "SET_COMPNAY_LOGO_URL";
export const LIST_DATA_TYPE_DATA = "LIST_DATA_TYPE_DATA";
export const LIST_DATA_TYPE_DATA_COMPANY = "LIST_DATA_TYPE_DATA_COMPANY";
export const LIST_DATA_TYPE_DATA_CLIENT = "LIST_DATA_TYPE_DATA_CLIENT";
export const LIST_DATA_TYPE_DATA_PLAN = "LIST_DATA_TYPE_DATA_PLAN";
export const SET_TRIGGER_UPLOAD_DATA = "SET_TRIGGER_UPLOAD_DATA";
export const SET_RAW_UPLOAD_MINIMIZED_STATUS = "SET_RAW_UPLOAD_MINIMIZED_STATUS";
export const SET_LOADING_PLAN_DATA_TYPE = "SET_LOADING_PLAN_DATA_TYPE";
export const IN_PROGRESS_RAW_UPLOAD_MESSAGE = "IN_PROGRESS_RAW_UPLOAD_MESSAGE";

//Language Provision
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_LANGUAGE_DATA = "SET_LANGUAGE_DATA";
export const RESET_LANGUAGE_DATA = "RESET_LANGUAGE_DATA";
export const CHECK_FOR_LANGUAGE = "CHECK_FOR_LANGUAGE";
export const UPDATE_STATE_COMPLETELY = "UPDATE_STATE_COMPLETELY";
